import { Box, Button, Paper, TextField, Typography } from "@mui/material";

import Grid from "@mui/material/Grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  addRechargeManual,
  addWhatsappMessageCount,
} from "./companyLoginApiHandler";

export default function RechargeForm({}) {
  const [date, setDate] = useState(dayjs().format("YYYY-MM-DD"));
  //   const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [mobile, setMobile] = useState("");
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [whatsappMobile, setwhatsappMobile] = useState("");
  const [countAmount, setCountAmount] = useState("");
  const handleRecharge = () => {
    if (!mobile || !rechargeAmount || !date) {
      alert("Please fill all fields");
      return;
    }

    const struct = {
      mobile: mobile.trim(),
      rechargeAmount: parseFloat(rechargeAmount),
      date: new Date(date).toISOString(),
    };

    console.log("Payload to send:", struct);

    addRechargeManual(struct, (res) => {
      console.log("Recharge success response: ", res);
      setMobile("");
      setRechargeAmount("");
      setDate(dayjs().format("YYYY-MM-DD"));
    });
  };

  const handleWhatsappMessageCount = () => {
    if (!whatsappMobile || !setCountAmount) {
      alert("Please fill all fields");
      return;
    }

    const struct = {
      mobile: whatsappMobile.trim(),
      count: parseFloat(countAmount),
      // date: new Date(date).toISOString(),
    };

    console.log("Payload to send:", struct);

    addWhatsappMessageCount(struct, (res) => {
      // console.log("Recharge success response: ", res);
      setwhatsappMobile("");
      setCountAmount("");
    });
  };
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={4}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B",
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Recharge
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          mt={4}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <Box sx={{ padding: "10px" }}>
            {/* Recharge Section */}
            <Box
              sx={{
                border: "1.5px solid #01008B",
                borderRadius: "8px",
                p: 2,
                mt: 2,
                position: "relative",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  position: "absolute",
                  top: "-16px",
                  left: "12px",
                  backgroundColor: "#fff",
                  px: 1,
                  fontWeight: 600,
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  color: "#01008B",
                }}
              >
                Recharge :
              </Typography>
              <Grid container spacing={2} sx={{ mb: 2, mt: 0.5 }}>
                <Grid item xs={12} md={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={date ? dayjs(date, "YYYY-MM-DD") : null}
                      onChange={(newValue) => {
                        setDate(newValue.format("YYYY-MM-DD"));
                        // setStartDate(newValue.format("YYYY-MM-DD"));
                      }}
                      format="DD-MM-YYYY"
                      error={!date}
                      slots={{ openPickerIcon: CalendarMonthIcon }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          label: "Validity Date",
                          size: "small",
                          InputLabelProps: {
                            sx: {
                              color: "#01008B",

                              // fontWeight: 400,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              // paddingX: "7px",
                            },
                          },
                          InputProps: {
                            sx: {
                              background: "#fff",
                              borderRadius: 1,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            },
                          },
                        },
                        openPickerIcon: {
                          sx: { color: "#000" },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Mobile Number"
                    size="small"
                    value={mobile}
                    onChange={(e) => {
                      const input = e.target.value;

                      // Allow only numbers and max 10 digits
                      if (/^\d{0,10}$/.test(input)) {
                        setMobile(input);
                        // if (mobileError) setMobileError(""); // Clear error on valid input
                      }
                    }}
                    helperText={
                      !!mobile && mobile.length > 0 && mobile.length !== 10
                        ? "Mobile number must be 10 digits"
                        : ""
                    }
                    InputLabelProps={{
                      sx: {
                        color: "#01008B",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      sx: {
                        color: "#01008B",
                        // fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // paddingX: "7px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Amount"
                    type="number"
                    size="small"
                    value={rechargeAmount}
                    onChange={(e) => setRechargeAmount(e.target.value)}
                    InputLabelProps={{
                      sx: {
                        color: "#01008B",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      sx: {
                        color: "#01008B",
                        // fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // paddingX: "7px",
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Box textAlign="center">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#01008B",
                    width: 200,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  onClick={handleRecharge}
                >
                  Recharge
                </Button>
              </Box>
            </Box>

            {/* Share Message Count Section */}
            <Box
              sx={{
                border: "1.5px solid #01008B",
                borderRadius: "8px",
                p: 2,
                mt: 6,
                position: "relative",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  position: "absolute",
                  top: "-16px",
                  left: "12px",
                  backgroundColor: "#fff",
                  px: 1,
                  fontSize: { xs: "14px", sm: "16px", md: "18px" },
                  fontWeight: 600,
                  color: "#01008B",
                }}
              >
                Share Message Count :
              </Typography>
              <Grid container spacing={2} sx={{ mb: 2, mt: 0.5 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Mobile Number"
                    size="small"
                    value={whatsappMobile}
                    onChange={(e) => {
                      const input = e.target.value;

                      if (/^\d{0,10}$/.test(input)) {
                        setwhatsappMobile(input);
                      }
                    }}
                    helperText={
                      !!whatsappMobile &&
                      whatsappMobile.length > 0 &&
                      whatsappMobile.length !== 10
                        ? "Mobile number must be 10 digits"
                        : ""
                    }
                    InputLabelProps={{
                      sx: {
                        color: "#01008B",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      sx: {
                        color: "#01008B",
                        // fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // paddingX: "7px",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Count"
                    type="number"
                    size="small"
                    value={countAmount}
                    onChange={(e) => setCountAmount(e.target.value)}
                    InputLabelProps={{
                      sx: {
                        color: "#01008B",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{
                      sx: {
                        color: "#01008B",
                        // fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // paddingX: "7px",
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <Box textAlign="center">
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#01008B",
                    width: 200,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  onClick={handleWhatsappMessageCount}
                >
                  Recharge
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>
    </>
  );
}
